import * as components from './components';
import '/src/assets/scss/app.scss';

import '@uniqoders/meteo-icons/font/meteo-icons.css';

const MeteoDS = {
  install(Vue, options = {}) {
    for (const componentName in components) {
      const component = components[componentName];
      Vue.component(component.name, component);
    }
  },
};

export default MeteoDS;

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(MeteoDS);
}
